export const dogBreeds = ['Afghan', 'African Wild Dog', 'Airedale', 'American Hairless',
'American Spaniel', 'Basenji', 'Basset', 'Beagle', 'Bearded Collie',
'Bermaise', 'Bichon Frise', 'Blenheim', 'Bloodhound', 'Bluetick',
'Border Collie', 'Borzoi', 'Boston Terrier', 'Boxer', 'Bull Mastiff',
'Bull Terrier', 'Bulldog', 'Cairn', 'Chihuahua', 'Chinese Crested', 'Chow',
'Clumber', 'Cockapoo', 'Cocker', 'Collie', 'Corgi', 'Coyote', 'Dalmation',
'Dhole', 'Dingo', 'Doberman', 'Elk Hound', 'French Bulldog', 'German Sheperd',
'Golden Retriever', 'Great Dane', 'Great Perenees', 'Greyhound',
'Groenendael', 'Irish Spaniel', 'Irish Wolfhound', 'Japanese Spaniel',
'Komondor', 'Labradoodle', 'Labrador', 'Lhasa', 'Malinois', 'Maltese',
'Mex Hairless', 'Newfoundland', 'Pekinese', 'Pit Bull', 'Pomeranian', 'Poodle',
'Pug', 'Rhodesian', 'Rottweiler', 'Saint Bernard', 'Schnauzer',
'Scotch Terrier', 'Shar_Pei', 'Shiba Inu', 'Shih-Tzu', 'Siberian Husky',
'Vizsla', 'Yorkie']

// export default dogBreeds